<template>
	<div class="start-page-bg">
		<div class="container start-page-container">
			<div class="row d-flex align-items-center justify-content-center vh-100">
				<div class="card text-center col-xl-5 col-lg-6 col-md-8">
					<div class="card-body">

						<div class="row justify-content-center" style="height: 45%;">
							<img src="@/assets/img/spark_logo_black.svg" alt="spark_logo"
								class="img-fluid card-img-top w-75" />
						</div>

						<hr />

						<div class="row justify-content-center mt-3">
							<h3> Validating... </h3>
						</div>

					</div>
				</div>

			</div>


		</div>
	</div>

</template>

<script>
import jwt_decode from 'jwt-decode';
import { sortAlphabetically } from '@/plugins/helper.js';

export default {
    async created() {
        await this.validate();
    },

    methods: {
        async validate() {
            const accessToken = this.$route.query.access_token;

            // 1. Redirect if no token is found
            if (!accessToken) {
                return this.$router.push({ name: 'index' });
            }

            try {
                // 2. Decode token and update Vuex store
                const decodedToken = jwt_decode(accessToken);
                this.$store.commit("auth/setAccessToken", accessToken);
                this.$store.commit("auth/setJwtPayload", decodedToken);
                this.$store.commit("auth/authenticated", true);

                // 3. Verify user has a recognized Spark role
                const { isSuperAdmin, isAdmin, isConsultant } = this.$store.state.auth;
                if (!isSuperAdmin && !isAdmin && !isConsultant) {
                    // No valid Spark role — log out with message
                    await this.$store.dispatch('auth/logout');
                    return;
                }

                // 4. Fetch Vertex users list
                this.getVertexSuperAdminUsers2();

                // 5. Redirect to the correct page
                const redirectLink = this.$store.state.auth.redirectLink;
                console.log(redirectLink)
                if (redirectLink) {
                    this.$store.commit("auth/setRedirectLink", null); // Clear link after use
                    this.$router.push({ path: redirectLink });
                } else {
                    this.$router.push({ name: 'dashboard' });
                }

            } catch (error) {
                // 6. Handle any errors during validation (e.g., bad token, API failure)
                console.error("Validation failed:", error);
                // Log the user out completely if validation fails
                await this.$store.dispatch('auth/logout');
                // Redirect to login with an error message
                this.$router.push({ name: 'index', query: { error: 'invalid_session' } });
            }
        },

        async getVertexSuperAdminUsers2() {
            try {
                const response = await this.$axios.get("/auth/users/super-admin");
                const users = response.data.super_admin_users;
				//console.log("users",users)
                //console.log("response",response.data)
                sortAlphabetically(users, (item) => item.first_name);
                this.$store.commit("auth/setUsersWithVertexRoles", users);
            } catch (error) {
                console.error("Error fetching super admin users:", error);
                // Re-throw the error to be caught by the validate method's catch block
                throw error;
            }
        },
    },
};
</script>
